import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import LeaveHistory from "../Leave/ApplyLeave/LeaveHistory";
import LeaveSummary from "../Leave/ApplyLeave/LeaveSummary";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ApplyCompOff = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Apply Comp Off"));
    fetchCoff();
    fetchHolidayDates();
  }, []);

  const intialFormdata =
  // {
  //   ProjectID: null,
  //   Purpose: "",
  //   FromDate: null,
  //   ToDate: null,
  //   days: 0,
  // },

  {
    Purpose: "",
    ProjectID: null,
    FromDate: null,
    ToDate: null,
    days: 0,
  };

  const [errors, setErrors] = useState({});
  const [projOptions, setProjOptions] = useState([]);
  const [summaryLeave, setSummaryLeave] = useState([]);
  const [CompHistory, setCompHistory] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [disabledDatess, setDisabledDatess] = useState([]);
  const [formData, setFormData] = useState(intialFormdata);
  const fetchCoff = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-compOff`);
      if (response.status === 200) {
        const projectopt = response?.data?.project;
        const projectOption = projectopt.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setProjOptions(projectOption);

        const leaveSummary = response?.data?.leaveSummary;
        setSummaryLeave(leaveSummary);

        const CompHistory = response?.data?.compOffHistory;
        setCompHistory(CompHistory);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Comp Off details:", error);
    }
  };

  const fetchHolidayDates = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}weekends-holidays`);
      if (response.status === 200) {
        const weekendHoliday = response?.data?.dates.map(
          (date) => new Date(date)
        );
        setDisabledDatess(weekendHoliday);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Weekend Holiday details:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const isWeekday = (date) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    // Get the first day of the next month
    const nextMonth = new Date(currentYear, currentMonth + 1, 1);

    // Get the first day of the current month
    const firstOfCurrentMonth = new Date(currentYear, currentMonth, 1);

    // Check if the date is in the last 3 months or next month
    const isInLastThreeMonths =
      date >= new Date(currentYear, currentMonth - 3, 1) &&
      date < firstOfCurrentMonth;
    const isInNextMonth = date >= nextMonth;

    // Disable all dates for the next month
    if (isInNextMonth) {
      return false;
    }

    // Enable holidays by checking if the date is in the disabledDatess array
    const isHoliday =
      Array.isArray(disabledDatess) &&
      disabledDatess.some((holidayDate) => {
        const holiday = new Date(holidayDate);
        return holiday.toDateString() === date.toDateString();
      });

    if (isHoliday) {
      return true; // Enable the holiday dates
    }

    return false; // Disable all other dates
  };
  const handleDateChange = (date, name) => {
    const selectedMonth = date.getMonth();

    if (name === "FromDate") {
      setFormData((prevState) => ({
        ...prevState,
        FromDate: date,
        ToDate: date, // Reset ToDate to FromDate when FromDate changes
        days: 1,
      }));
    } else if (name === "ToDate") {
      // Check if ToDate is before FromDate
      if (date < formData.FromDate) {
        toast.error("To Date cannot be before From Date");
        return;
      }

      // Check if months are the same
      if (date.getMonth() !== formData.FromDate.getMonth()) {
        toast.error("FromDate and ToDate must be in the same month");
        return;
      }

      setFormData((prevState) => ({
        ...prevState,
        ToDate: date,
      }));

      calculateDays(formData.FromDate, date);
    }
  };
  const calculateDays = (fromDate, toDate) => {
    if (fromDate && toDate) {
      let currentDate = new Date(fromDate);
      let daysDiff = 0;
      while (currentDate <= toDate) {
        if (isWeekday(currentDate)) {
          daysDiff++;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setFormData((prevState) => ({
        ...prevState,
        days: daysDiff || 0,
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.Purpose?.trim()) {
      newErrors.Purpose = "Purpose is required";
    }
    if (!formData.ProjectID) newErrors.ProjectID = "Project is required";
    if (!formData.FromDate) newErrors.FromDate = "From Date is required";
    if (!formData.ToDate) newErrors.ToDate = "To Date is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formattedData = {
        ...formData,
        FromDate: formData.FromDate
          ? moment(formData.FromDate).format("YYYY-MM-DD")
          : null,
        ToDate: formData.ToDate
          ? moment(formData.ToDate).format("YYYY-MM-DD")
          : null,
      };
      setSubmit(true);
      PostServiceCaller(`${API_URL}apply-compOff`, formattedData, "post")
        .then((response) => {
          if (response?.status == 200) {
            toast.success("Comp Off submitted successfully!");
            fetchCoff();
            setSubmit(false);
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
          toast.error("Failed to submit Comp Off. Please try again!");
          setSubmit(false);
        });
    }
  };

  const handleEdit = (id) => {
    navigate(`/apply-comp-off/edit/${id}`);
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row gx-lg-1">
            <div className="col-12 col-lg-7 pe-1">
              <div className="container-fluid" id="skill-table-area">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <label htmlFor="project" className="form-label">
                        Project<span className="required">*</span>
                      </label>
                      <Select
                        options={projOptions}
                        onChange={(option) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            ProjectID: option ? option.value : "",
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            ProjectID: "",
                          }));
                        }}
                        value={
                          projOptions.find(
                            (option) => option.value === formData.ProjectID
                          ) || null
                        }
                        placeholder="Select a project"
                        styles={{
                          control: (provided, state) => ({
                            ...provided,
                            border: errors.ProjectID
                              ? "1px solid #dc3545"
                              : "1px solid #ced4da",
                            borderRadius: "0.375rem",
                            minHeight: "38px",
                            boxShadow: state.isFocused
                              ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                              : "none",
                            "&:hover": {
                              borderColor: errors.ProjectID
                                ? "#dc3545"
                                : "#adb5bd",
                            },
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: "#6c757d",
                          }),
                        }}
                      />

                      {errors.ProjectID && (
                        <div className="error-msg">{errors.ProjectID}</div>
                      )}
                    </div>
                    <div className="mt-2">
                      <label htmlFor="Purpose" className="form-label">
                        Purpose<span className="required">*</span>
                      </label>
                      <textarea
                        className={`form-control ${errors.Purpose ? "is-invalid" : ""
                          }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        onChange={handleInputChange}
                      />
                      {errors.Purpose && (
                        <div className="error-msg">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="FromDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        showPopperArrow
                        showIcon
                        className="form-control"
                        name="FromDate"
                        id="FromDate"
                        filterDate={isWeekday}
                        dateFormat="dd-MMM-yyyy"
                        selected={formData.FromDate || null}
                        onChange={(date) => {
                          handleDateChange(date, "FromDate");
                          if (date) {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              FromDate: "",
                              ToDate:
                                formData.ToDate &&
                                  moment(date).isAfter(moment(formData.ToDate))
                                  ? "To Date cannot be before From Date"
                                  : "",
                            }));
                          }
                        }}
                        maxDate={moment().endOf("month").toDate()}
                      />
                      {errors.FromDate && (
                        <div className="error-msg">{errors.FromDate}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-5 mt-2">
                      <label htmlFor="ToDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        showPopperArrow
                        showIcon
                        filterDate={isWeekday}
                        className="form-control"
                        name="ToDate"
                        id="ToDate"
                        dateFormat="dd-MMM-yyyy"
                        selected={formData.ToDate || null}
                        onChange={(date) => {
                          handleDateChange(date, "ToDate");
                          if (date) {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              ToDate:
                                formData.FromDate &&
                                  moment(date).isBefore(moment(formData.FromDate))
                                  ? "To Date cannot be before From Date"
                                  : "",
                            }));
                          }
                        }}
                        minDate={formData.FromDate || undefined}
                        maxDate={moment().endOf("month").toDate()}
                      />
                      {errors.FromDate && (
                        <div className="error-msg">{errors.ToDate}</div>
                      )}
                    </div>
                    <div className="col-sm-12 col-md-2 mt-2">
                      <div className="mb-3">
                        <label htmlFor="days" className="form-label">
                          No. of Days<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={formData.days}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-2">
                    <h6 className="mt-1">
                      * Comp Off can be applied only for non-working days.
                    </h6>
                    <div className="text-end mt-2">
                      <button type="submit" className="custom-btn">
                        {submitted ? (
                          <FaSpinner class="sm-spinner" />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-12 col-lg-5 pe-1">
              <LeaveSummary leaveDetails={summaryLeave} />
              <LeaveHistory
                leaveHistory={CompHistory}
                showAction={true}
                title="Comp-Off History"
                onEdit={handleEdit}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ApplyCompOff;
